import type { FaireProductEntity } from "../../entity_types/product";

export const p_bekx8fcudn: FaireProductEntity = {
  token: "p_bekx8fcudn",
  type: "product",
  name: "Women's Cozy 36\" Ruffle Chenille Robe",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/77e7c3a1a13039bae50ccf5a7f454b87c89e2d9a6466a9cff851d3b80d73706c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43d02c7521286e17e94056d92283499edb00e01bc9c8cf9721cd07ae215c9a31.jpeg",
    "https://cdn.faire.com/fastly/c2ceb3aeb39fc2d45aa19b2f36ca12be2a741ad722a3e023bc15c3df589c50bc.jpeg",
    "https://cdn.faire.com/fastly/7b7e4299fb668cfe27e4e4c42acebf11ea604cbf1718ce94430aca75f38db159.jpeg",
    "https://cdn.faire.com/fastly/2571bb67b7d427b05b26639c284744247be75d553e4f2e63db347fa599966773.jpeg",
    "https://cdn.faire.com/fastly/a5b91bb4f5d0e7037551e4ca593ff7c63a2a9e841095f61c762b8b5160ea85e3.jpeg",
    "https://cdn.faire.com/fastly/3d8a79f386a1c02582e0a058b8c1820645952fc0be45fa836aed91aa3f08ce23.jpeg",
    "https://cdn.faire.com/fastly/ce64fd43bbb96211bd5292129f166177d9726d094a4a2d6689b5b73e1b1204cf.png",
    "https://cdn.faire.com/fastly/054137ca98618e1423eed3479bac0705ecace5d50de366a65ecd771ef3330d4f.jpeg",
    "https://cdn.faire.com/fastly/1d02786a319a8f398c9f9ad66878e28dab6544620708f4402a38947f972c11b8.jpeg",
    "https://cdn.faire.com/fastly/d0a04a6b46742e1e4aa020be23b86164c137662c8960b26228ee6fb5118ab41a.jpeg",
    "https://cdn.faire.com/fastly/2d79c3ce07686b46f627ca74cd0ec486b2491b3a96b5354c0f0ce3b888ced55c.jpeg",
    "https://cdn.faire.com/fastly/bb5d6343201638a2177bc16f391051777a7800ca6f3c1b8396f4c482df367be5.jpeg",
    "https://cdn.faire.com/fastly/520cd3cb92c41d0d2866068a981b10141400b0f0de3651d0f39bbf348619e2be.jpeg",
    "https://cdn.faire.com/fastly/1763cb5e3e04b94cc967d260d32c7ac7226fe59431e512367fb9e32552801d1a.png"
  ],
  priceDollars: 60,
  description: "Fashionably cut just above the knee, this 36” ruffle chenille robe is warmth without weight – perfect for taking the chill out of a morning. The inside tie gently hugs your waist and keeps the robe safe and secure. Plus, the hidden side seam pockets make this chenille robe extra convenient.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• 36” ruffled trim robe features hand stitched cascading ruffle\n• Inside tie, and hidden side seam pockets.\n• Bracelet length sleeves and fashionable bell sweep\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• 100% polyester chenille\n• Easy-care, colorfast and lightweight\n• Machine washable",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:05.525Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
